(function () {
  'use strict';

  /** Retorna os valores de tamanho ativos na URL atual */
  function getActiveSizeFilters() {
    const params = new URLSearchParams(window.location.search);
    const sizes = [];
    for (const [key, value] of params.entries()) {
      const k = key.toLowerCase();
      if (k.includes('filter') && (k.includes('size') || k.includes('tamanho'))) {
        sizes.push(value.toLowerCase());
      }
    }
    return sizes;
  }

  /**
   * Busca disponibilidade de um produto via API pública (sem token)
   * Retorna true se tiver variante do tamanho disponível em estoque
   */
  async function checkProductAvailability(handle, sizeValues) {
    try {
      const res = await fetch(`/products/${handle}.js`);
      if (!res.ok) return true;
      const product = await res.json();

      return product.variants.some((variant) => {
        if (!variant.available) return false;
        return variant.options.some((opt) =>
          sizeValues.includes(opt.toLowerCase())
        );
      });
    } catch (e) {
      return true;
    }
  }

  /** Mostra/oculta mensagem de "nenhum resultado" */
  function updateEmptyState(grid) {
    const hidden = grid.querySelectorAll('li[data-avail-hidden]');
    const total = grid.querySelectorAll('li[data-product-handle]');
    let msg = document.querySelector('.avail-filter-empty');

    if (hidden.length === total.length && total.length > 0) {
      if (!msg) {
        msg = document.createElement('p');
        msg.className = 'avail-filter-empty';
        msg.style.cssText = 'grid-column:1/-1;text-align:center;padding:2rem 0;opacity:.6;';
        msg.textContent = 'Nenhum produto disponível neste tamanho.';
        grid.parentElement?.appendChild(msg);
      }
    } else {
      msg?.remove();
    }
  }

  /** Lógica principal */
  async function applyFilter() {
    const sizeValues = getActiveSizeFilters();
    const grid = document.querySelector('ul.product-grid');
    if (!grid) return;

    if (sizeValues.length === 0) {
      grid.querySelectorAll('li[data-avail-hidden]').forEach((c) => {
        c.style.display = '';
        c.removeAttribute('data-avail-hidden');
      });
      document.querySelector('.avail-filter-empty')?.remove();
      return;
    }

    const cards = Array.from(grid.querySelectorAll('li[data-product-handle]'));
    if (!cards.length) return;

    await Promise.all(
      cards.map(async (card) => {
        const handle = card.dataset.productHandle;
        if (!handle) return;

        const available = await checkProductAvailability(handle, sizeValues);

        if (available) {
          card.style.display = '';
          card.removeAttribute('data-avail-hidden');
        } else {
          card.style.display = 'none';
          card.setAttribute('data-avail-hidden', 'true');
        }
      })
    );

    updateEmptyState(grid);
  }

  /** Debounce */
  function debounce(fn, ms) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn(...args), ms);
    };
  }

  const debouncedApply = debounce(applyFilter, 500);

  /** Observa o container pai para detectar re-renders do sectionRenderer */
  function observeGrid() {
    const container = document.querySelector('results-list');
    if (!container) return;
    new MutationObserver(debouncedApply).observe(container, {
      childList: true,
      subtree: true,
    });
  }

  function init() {
    observeGrid();
    applyFilter();

    const originalPushState = history.pushState.bind(history);
    history.pushState = function (...args) {
      originalPushState(...args);
      setTimeout(applyFilter, 800);
    };
  }

  window.addEventListener('popstate', debouncedApply);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
